// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"613":"45432828","2589":"d6fdf0fb","3059":"0ea2174c","9671":"d0c0450a"}[chunkId] + ".css";
};